import * as types from './types';

export const setAdminSchoolsLoading = (isLoading = false) => ({
  type: types.ADMIN_SCHOOLS_SET_LIST_LOADING,
  isLoading
});

export const getAdminSchools = (queryParams) => ({
  type: types.ADMIN_SCHOOLS_GET_LIST,
  queryParams
});

export const setAdminSchools = adminSchools => ({
  type: types.ADMIN_SCHOOLS_SET_LIST,
  adminSchools
});

export const resetAdminSchools = () => ({
  type: types.ADMIN_SCHOOLS_RESET_LIST
});


// WEBPACK FOOTER //
// ./src/actions/admin/schools/index.js